import {
    ATTEMPT_FETCH_ACCOUNT_ORGANIZATIONS,
    FETCH_ACCOUNT_ORGANIZATIONS_SUCCEEDED,
    SWITCH_ORGANIZATION,
    SIGN_OUT_SUCCEEDED,
    ATTEMPT_CREATE_ORGANIZATION,
    CREATE_ORGANIZATION_SUCCEEDED,
    CREATE_ORGANIZATION_FAILED,
} from 'shared_redux/actions';

import {
    UPDATE_ORGANIZATION_NAME_SUCCESS,
} from 'features/settings/staff/actions';

const defaultState = {
    availableOrganizations: [],
    currentOrganizationId: localStorage.getItem('selectedOrganizationId'),
    isLoading: false,
    isCreating: false,
    createError: null,
};

export default function organizationSwitcher(state = defaultState, action) {
    switch (action.type) {
        case ATTEMPT_FETCH_ACCOUNT_ORGANIZATIONS:
            return {
                ...state,
                isLoading: true,
            };
        case FETCH_ACCOUNT_ORGANIZATIONS_SUCCEEDED:
            const organizations = action.payload || [];
            // Set current organization to localStorage value, or first one if none is set
            const storedOrgId = localStorage.getItem('selectedOrganizationId');
            const currentOrgId = storedOrgId || state.currentOrganizationId || 
                (organizations.length > 0 ? organizations[0].org_id : null);
            
            // Update localStorage if we're using a new org
            if (currentOrgId && currentOrgId !== storedOrgId) {
                localStorage.setItem('selectedOrganizationId', currentOrgId);
            }
            
            return {
                ...state,
                availableOrganizations: organizations,
                currentOrganizationId: currentOrgId,
                isLoading: false,
            };
        case SWITCH_ORGANIZATION:
            // Also store in localStorage immediately for API calls
            localStorage.setItem('selectedOrganizationId', action.payload.organizationId);
            return {
                ...state,
                currentOrganizationId: action.payload.organizationId,
            };
        case UPDATE_ORGANIZATION_NAME_SUCCESS:
            const updatedOrg = action.payload.organization;
            return {
                ...state,
                availableOrganizations: state.availableOrganizations.map(orgRole => {
                    if (orgRole.org_id === updatedOrg.id) {
                        return {
                            ...orgRole,
                            organization: {
                                ...orgRole.organization,
                                name: updatedOrg.name,
                            }
                        };
                    }
                    return orgRole;
                })
            };
        case ATTEMPT_CREATE_ORGANIZATION:
            return {
                ...state,
                isCreating: true,
                createError: null
            };
        case CREATE_ORGANIZATION_SUCCEEDED:
            const newOrg = action.payload;
            // Convert to the expected format for organization roles
            const newOrgRole = {
                org_id: newOrg.id,
                organization: newOrg,
                role: 'OWNER'
            };
            return {
                ...state,
                availableOrganizations: [...state.availableOrganizations, newOrgRole],
                isCreating: false,
                createError: null
            };
        case CREATE_ORGANIZATION_FAILED:
            return {
                ...state,
                isCreating: false,
                createError: action.error || 'Failed to create organization'
            };
        case SIGN_OUT_SUCCEEDED:
            localStorage.removeItem('selectedOrganizationId');
            return defaultState;
        default:
            return state;
    }
}